import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  CORPORATE_QUERY_PARAM,
  readCorporateSessionFlag,
  writeCorporateSessionFlag,
  subscribeCorporateExit,
} from "lib/corporateModeSession";

const CorporateModeContext = createContext({
  isCorporate: false,
  exitCorporateMode: () => {},
});

export function CorporateModeProvider({ children }) {
  const location = useLocation();
  const history = useHistory();
  const [isCorporate, setIsCorporate] = useState(() =>
    readCorporateSessionFlag()
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const flag = params.get(CORPORATE_QUERY_PARAM);

    if (flag === "true") {
      writeCorporateSessionFlag(true);
      setIsCorporate(true);
    } else if (flag === "false") {
      writeCorporateSessionFlag(false);
      setIsCorporate(false);
    } else {
      setIsCorporate(readCorporateSessionFlag());
    }
  }, [location.search]);

  useEffect(() => {
    return subscribeCorporateExit(() => setIsCorporate(false));
  }, []);

  const exitCorporateMode = useCallback(() => {
    writeCorporateSessionFlag(false);
    setIsCorporate(false);
    const params = new URLSearchParams(location.search);
    params.delete(CORPORATE_QUERY_PARAM);
    const qs = params.toString();
    history.replace({
      pathname: location.pathname,
      search: qs ? `?${qs}` : "",
    });
  }, [history, location.pathname, location.search]);

  const value = useMemo(
    () => ({ isCorporate, exitCorporateMode }),
    [isCorporate, exitCorporateMode]
  );

  return (
    <CorporateModeContext.Provider value={value}>
      {children}
    </CorporateModeContext.Provider>
  );
}

export function useCorporateMode() {
  const ctx = useContext(CorporateModeContext);
  if (!ctx) {
    throw new Error(
      "useCorporateMode must be used within CorporateModeProvider"
    );
  }
  return ctx;
}
